import { RARITY_COLORS, LEGENDARY_ABILITIES, formatStatMods } from '../../data/items';
import { ItemTooltip } from './ItemTooltip';

/**
 * A single equipment slot in the paper-doll layout.
 *
 * Empty  → shows slot icon + label placeholder.
 * Filled → shows item icon + rarity border + hover tooltip.
 *          Clicking calls onUnequip(slotId).
 */
export function EquipmentSlot({ id, label, icon, gridColumn, gridRow, item, onUnequip, equippedSetCount }) {
  if (item) {
    const color   = RARITY_COLORS[item.rarity] ?? '#9e9e9e';
    const lines   = formatStatMods(item.statMods);
    const ability = item.abilityId ? LEGENDARY_ABILITIES[item.abilityId] : null;

    return (
      <div
        className={`equipment-slot equipment-slot--filled${item.rarity === 'set' ? ' equipment-slot--set-glow' : ''}`}
        style={{ gridColumn, gridRow, '--rarity-color': color }}
        onClick={() => onUnequip(id)}
      >
        <span className="equipment-slot-icon">{item.icon}</span>
        <span className="equipment-slot-label equipment-slot-label--filled">{item.name}</span>

        {/* Enhancement badge — shown when the equipped item has been enhanced */}
        {item.enhancement && (
          <span className="item-slot-enh-badge" title={`Enhanced Lv ${item.enhancement.level}`}>✦</span>
        )}

        <ItemTooltip
          item={item}
          color={color}
          lines={lines}
          ability={ability}
          equippedSetCount={equippedSetCount}
          levelReq={item.levelReq ?? 1}
          isEquipmentSlot
          tooltipSide={gridColumn === 1 ? 'right' : 'center'}
        />
      </div>
    );
  }

  return (
    <div
      className="equipment-slot"
      style={{ gridColumn, gridRow }}
      title={label}
    >
      <span className="equipment-slot-icon">{icon}</span>
      <span className="equipment-slot-label">{label}</span>
    </div>
  );
}
